import { GradientParser } from '../../lib/gradient';
import { loadImage } from './image';
import { extractShaderColors, isShaderGradientFill, renderShaderFill } from './shader-fill';
// "url(\"https://www.transparenttextures.com/patterns/old-map.png\")"
function isURLFill(fill) {
  if (typeof fill !== 'string') return false;
  // Match CSS url() pattern with optional quotes and whitespace
  return /^url\s*\(\s*(["']?)([^"']+)\1\s*\)$/.test(fill.trim());
}

function parseURLFill(fill) {
  if (!isURLFill(fill)) return null;

  // Extract the URL from the url() pattern
  const match = fill.trim().match(/^url\s*\(\s*(["']?)([^"']+)\1\s*\)$/);
  if (match && match[2]) {
    return match[2];
  }
  return null;
}

export function createFill(renderContext, fill, node, render) {
  const { context } = renderContext;
  try {
    render =
      render ||
      (() => {
        context.fill();
      });
    if (isShaderGradientFill(fill)) {
      const handled = renderShaderFill(renderContext, fill, node);
      if (handled) return;
      // graceful fallback using provided colors if any
      const colors = extractShaderColors(fill);
      if (colors.length >= 2) {
        const stops = colors.map((c, i) => `${c} ${(i / (colors.length - 1)) * 100}%`).join(', ');
        const gradient = `linear-gradient(90deg, ${stops})`;
        GradientParser.create(
          context,
          gradient,
          {
            x: node.x,
            y: node.y,
            w: Math.abs(node.w),
            h: Math.abs(node.h),
          },
          render,
        );
        return;
      } else if (colors.length === 1) {
        context.fillStyle = colors[0];
        render();
        return;
      }
      // if not handled, fallthrough to other types for graceful degrade
    }
    if (GradientParser.is(fill)) {
      GradientParser.create(
        context,
        fill,
        {
          x: node.x,
          y: node.y,
          w: Math.abs(node.w),
          h: Math.abs(node.h),
        },
        render,
      );
    } else if (isURLFill(fill)) {
      const url = parseURLFill(fill);
      if (url) {
        const img = loadImage(renderContext, url, null, node);
        const pattern = context.createPattern(img.img, 'repeat');
        context.fillStyle = pattern;
        render();
      } else {
        context.fillStyle = '#ffffff'; // Fallback if URL is invalid
        render();
      }
    } else {
      if (fill !== 'none') {
        context.fillStyle = fill || '#ffffff';
        render();
      }
    }
  } catch {}
}
